<template>
    <b-card :title="$translate('filters')" class="query-filter filter-form" body-class="p-0 mt-3">
        <div>
            <b-row>
             
                <b-col cols="12" md="6" class="mt-3">
                    <label for="input-activity" class="mb-3"><strong>{{ $translate('start_date')
                    }}</strong></label>
                    <b-input id="input-start-date" type="date" :placeholder="$translate('start_date')" v-model="filtersModel.start_date"></b-input>
                </b-col>
                <b-col cols="12" md="6" class="mt-3">
                    <label for="input-activity" class="mb-3"><strong>{{ $translate('end_date')
                    }}</strong></label>
                    <b-input id="input-start-date" type="date" :placeholder="$translate('end_date')" v-model="filtersModel.end_date"></b-input>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <b-form-checkbox v-model="filtersModel.enableDateTimeFilter">
                      {{ $translate('enable_date_time_filter') }}
                    </b-form-checkbox>
                  </b-col>
              
                  <!-- Conditional Date, Start Time, and End Time Fields -->
                  <b-col cols="12" md="6" class="mt-3" v-if="filtersModel.enableDateTimeFilter">
                    <label for="input-filter-date" class="mb-3">
                      <strong>{{ $translate('filter_date') }}</strong>
                    </label>
                    <b-input
                      id="input-filter-date"
                      type="date"
                      :placeholder="$translate('date')"
                      v-model="filtersModel.filter_date"
                    ></b-input>
                  </b-col>
                  <b-col cols="12" md="6" class="mt-3" v-if="filtersModel.enableDateTimeFilter">
                    <label for="input-start-time" class="mb-3">
                      <strong>{{ $translate('start_time') }}</strong>
                    </label>
                    <b-input
                      id="input-start-time"
                      type="time"
                      :placeholder="$translate('start_time')"
                      v-model="filtersModel.start_time"
                    ></b-input>
                  </b-col>
                  <b-col cols="12" md="6" class="mt-3" v-if="filtersModel.enableDateTimeFilter">
                    <label for="input-end-time" class="mb-3">
                      <strong>{{ $translate('end_time') }}</strong>
                    </label>
                    <b-input
                      id="input-end-time"
                      type="time"
                      :placeholder="$translate('end_time')"
                      v-model="filtersModel.end_time"
                    ></b-input>
                  </b-col>
            </b-row>
        </div>
    </b-card>
</template>

<script>
// import CustomerTypeAhead from "@/components/CustomerTypeAhead.vue";

export default {
    name: 'roster-filters',
    data(){
        return {

            quantities: [
                { id: 1, name: '=' },
                { id: 2, name: '>' },
                { id: 3, name: '<' },
            ],
        }
    },  
    props: ['value'],
    // components:{CustomerTypeAhead },
    mounted() {
    this.setDefaultDateRange();
  },
    computed: {
        filtersModel: {
            // getter
            get() {
                return this.value
            },
            // setter
            set(val) {
                this.$emit('input', val)
            },
        },

        paymentTransactionStatus() {
            return {
                pending: "Pending",
                processed: "Processed",
                cancelled: "Cancelled"
            }
        },

        transaction_type() {
            return {
                incoming: 'Incoming',
                outgoing: 'Outgoing',
            };
        },
 
    },

    watch: {},

    methods: {
        setDefaultDateRange() {
      const currentDate = new Date();
      const currentDay = currentDate.getDay();
      const diffToSunday = currentDay === 0 ? 0 : 7 - currentDay;

      // Calculate the start date (two Sundays ago)
      const startDate = new Date(currentDate);
      startDate.setDate(currentDate.getDate() - currentDay + diffToSunday - 7);

      // Calculate the end date (next Saturday)
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 13);

      // Format dates to YYYY-MM-DD for the date input fields
      const formatDate = (date) => {
        return date.toISOString().split('T')[0];
      };

      this.filtersModel.start_date = formatDate(startDate);
      this.filtersModel.end_date = formatDate(endDate);
      const defaultStartTime = '10:00'; // Default start time
      const defaultEndTime = '19:00'; // Default end time
      this.filtersModel.filter_date = formatDate(currentDate); // Set current date as the filter date
      this.filtersModel.start_time = defaultStartTime;
      this.filtersModel.end_time = defaultEndTime;
    }
    }
}
</script>
